import { Card, CardContent, Grid } from '@mui/material';
import FormActions from './components/FormActions/FormActions';
import FormStepper from './components/FormStepper/FormStepper';
import Results from './components/Results/Results';
import useFormService from './hooks/useFormService';

const SavingsCalculator = () => {
  const {
    values,
    step,
    savings,
    setStepValue,
    resetFormState,
    calculateSavings,
  } = useFormService();
  return (
    <Grid container spacing={3} maxWidth="lg" className="!mt-1 min-h-[75vh]">
      <Grid item xs={12} md={8}>
        <Card>
          <CardContent className="flex flex-row">
            <FormStepper
              activeStep={step}
              values={values}
              setStepValue={setStepValue}
            />
          </CardContent>
          <FormActions
            values={values}
            calculateSavings={calculateSavings}
            resetFormState={resetFormState}
          />
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card className={savings > 0 ? '!bg-[#006BF8]' : ''}>
          <CardContent className="relative !p-7">
            <Results value={savings} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SavingsCalculator;
